import React from "react";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@shadcn-in-nx/ui/toggle-group";

const STATUS_OPTIONS = [
    { value: "all", labelKey: "activity.showAll" },
    { value: "SUCCESS", labelKey: "activity.showWorked" },
    { value: "FAILURE", labelKey: "activity.showFailed" },
    { value: "THROTTLED", labelKey: "activity.showTooBusy" },
];

const TIME_OPTIONS = [
    { value: "1h", labelKey: "activity.lastHour" },
    { value: "6h", labelKey: "activity.last6Hours" },
    { value: "24h", labelKey: "activity.today" },
    { value: "7d", labelKey: "activity.thisWeek" },
];

function SegmentGroup({ value, options, onChange, t }) {
    return (
        <ToggleGroup
            type="single"
            variant="outline"
            value={value}
            onValueChange={(v) => v && onChange(v)}
            className="flex gap-0"
        >
            {options.map((opt) => (
                <ToggleGroupItem
                    key={opt.value}
                    value={opt.value}
                    className="h-8 px-3 text-xs rounded-none border-0 border-r border-gray-200 first:rounded-l-md last:rounded-r-md last:border-r-0 data-[state=on]:bg-blue-50 data-[state=on]:text-blue-700 data-[state=on]:font-semibold"
                >
                    {t(opt.labelKey)}
                </ToggleGroupItem>
            ))}
        </ToggleGroup>
    );
}

function ActivityFilters({ filters, onChange }) {
    const { t } = useTranslation();
    const update = (key, value) => onChange({ ...filters, [key]: value });

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 space-y-3">
            <div className="flex flex-wrap items-center gap-2">
                <div className="border border-gray-200 rounded-md overflow-hidden">
                    <SegmentGroup
                        value={filters.status}
                        options={STATUS_OPTIONS}
                        onChange={(v) => update("status", v)}
                        t={t}
                    />
                </div>
                <div className="border border-gray-200 rounded-md overflow-hidden">
                    <SegmentGroup
                        value={filters.timeRange}
                        options={TIME_OPTIONS}
                        onChange={(v) => update("timeRange", v)}
                        t={t}
                    />
                </div>
            </div>
            <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                    type="text"
                    placeholder={t("activity.searchPath")}
                    value={filters.pathSearch}
                    onChange={(e) => update("pathSearch", e.target.value)}
                    className="w-full text-sm border border-gray-200 rounded-md pl-9 pr-3 py-2 bg-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 transition"
                />
            </div>
        </div>
    );
}

export default ActivityFilters;
